import type { ExtensionNavigationState } from '@/hooks/use-extension-navigation.hook';

/** How the extension tab shows the installer to a browser without it. */
export interface ExtensionInstallerView {
  installationAware: boolean;
  trackInstallReturn: boolean;
  installationState: { isReady: boolean; isInstalled: boolean };
}

/**
 * The Integrations page's Browser Extension tab. It shows once this browser
 * confirms the extension. The tabbed sidebar has no Extension row, so it also
 * shows wherever that row did, as the installer the row led to.
 */
export function extensionTab(nav: ExtensionNavigationState): {
  enabled: boolean;
  installer: ExtensionInstallerView | null;
} {
  if (nav.showIntegrationsSurface) return { enabled: true, installer: null };
  if (nav.showSidebarInstaller)
    return {
      enabled: true,
      installer: {
        installationAware: true,
        trackInstallReturn: true,
        installationState: {
          isReady: nav.detectionReady,
          isInstalled: nav.installedInBrowser,
        },
      },
    };
  return { enabled: false, installer: null };
}

/** Whether /extension sends people to the Integrations tab instead. */
export function extensionRouteRedirects(
  nav: ExtensionNavigationState
): boolean {
  return extensionTab(nav).enabled;
}
